export default {
  'menu.welcome': '欢迎',
  'menu.home': '首页',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  // 一、平台驾驶舱（概览已合并到生态健康度）
  'menu.dashboard': '平台驾驶舱',
  'menu.dashboard.analysis': '生态健康度',
  'menu.dashboard.monitor': '监控与榜单',
  'menu.dashboard.workplace': '商业沙盘',
  // 二、模型底座与官方资产池
  'menu.infrastructure': '模型底座与资产池',
  'menu.infrastructure.gateway': '模型网关',
  'menu.infrastructure.templates': '官方模板库',
  'menu.infrastructure.tools': '公共插件与知识库',
  // 三、市场货架与商业化
  'menu.market': '市场与商业化',
  'menu.market.categories': '类目树',
  'menu.market.approval': '上架审批',
  'menu.market.recommend': '推荐位',
  'menu.market.sku': '定价中枢',
  'menu.market.independent-deploy': '独立部署',
  'menu.market.settlement': '分润结算',
  'menu.market.points': '积分管理',
  'menu.market.pricing-rules': '售价规则',
  'menu.market.membership': '套餐管理',
  // 运营：智能组管理（可查看组内所有智能体）
  'menu.operate': '运营',
  'menu.operate.workgroups': '智能组管理',
  'menu.operate.vip-orders': 'VIP订单',
  'menu.operate.redeem-codes': '兑换码管理',
  // 四、用户/创作者全景
  'menu.user-creator': '用户与创作者',
  'menu.user-creator.users': '用户管控',
  'menu.user-creator.creator': '创作者产能',
  // 五、AI 质量与进化
  'menu.quality': '质量与进化',
  'menu.quality.badcase': '对话质检',
  'menu.quality.prompt-repo': '提示词库',
  'menu.quality.ab-test': 'A/B 实验室',
  // 六、合规风控
  'menu.compliance': '系统与审计',
  'menu.compliance.admin-users': '管理员用户管理',
  'menu.compliance.system-logs': '操作日志',
  // 个人与系统
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.logout': '退出登录',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
};
